import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';
import { Link } from 'react-router-dom';
import {
    EmailShareButton, FacebookShareButton, LinkedinShareButton,
    WhatsappShareButton, FacebookIcon, EmailIcon, LinkedinIcon, WhatsappIcon,
} from 'react-share';

import NoData from './../../no-data/no-data.component';

// styles , icons and images
import { Row, Col, Card, Modal } from 'react-bootstrap';
import { Paper, Button, Fab, Tooltip } from '@material-ui/core';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags';
import dots from '../../record/images/more.png';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ShareIcon from '@material-ui/icons/Share';
import CodeSharpIcon from '@material-ui/icons/CodeSharp';
import img from '../../../images/image-place.png';


// this component represents the video card in visumes/biographies page  

class CardBiography extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copy: 'Copy',
            arrayOfDurations: []
        }
    }
    arrayOfDuration = []
    handleClose = () => this.setState({ ...this.state, show: false });
    handleShow = () => this.setState({ ...this.state, show: true });
    handleCloseDeleteModal = () => { this.setState({ ...this.state, showDeleteModal: false }) }
    handleCloseShareModal = () => { this.setState({ ...this.state, showShareModal: false, copy: "Copy" }) }
    handleClick = (e) => {
        let elem = e.currentTarget;
        if (elem.querySelector('.custom-list')) {
            elem.querySelector('.custom-list').classList.toggle('d-none')
        }
    }
    handleCuePoints = () => {
        this.arrayOfDuration = []
        if (this.state.bioSelected) {
            for (let i = 0; i < this.state.bioSelected.questions.length; i++) {
                if (i === 0) {
                    let temp = this.state.bioSelected.questions[0];
                    temp.start_time = 0;
                    if (temp) {
                        this.arrayOfDuration.push(temp);
                    }
                }
                else if (i === 1) {
                    let temp = this.state.bioSelected.questions[1];
                    temp.start_time = 5 + this.state.bioSelected.questions[0].video.duration;
                    if (temp) {
                        this.arrayOfDuration.push(temp);
                    }
                }
                else if (i === 2) {
                    let temp = this.state.bioSelected.questions[2];
                    temp.start_time = this.arrayOfDuration[1].start_time + 4 + this.state.bioSelected.questions[1].video.duration
                    if (temp) {
                        this.arrayOfDuration.push(temp);
                    }
                }
                else if (i === 3) {
                    let temp = this.state.bioSelected.questions[3];
                    temp.start_time = this.arrayOfDuration[2].start_time + 5 + this.state.bioSelected.questions[2].video.duration
                    if (temp) {
                        this.arrayOfDuration.push(temp);
                    }
                }
                else if (i === 4) {
                    let temp = this.state.bioSelected.questions[4];
                    temp.start_time = this.arrayOfDuration[3].start_time + 5 + this.state.bioSelected.questions[3].video.duration
                    if (temp) {
                        this.arrayOfDuration.push(temp);
                    }
                }
            }
        }
    }
    render() {
        this.handleCuePoints();
        if (!this.props.data[0]) {
            return (
                <NoData />
            )
        }
        else {
            return (
                <Row className="m-0 p-3 pt-4 ">{
                        this.props.data.map(bio => {
                            return (
                                <Col className="p-3 " md='4'>
                                    <Card className="text-dark border-0 biographies">
                                        {(bio.video) ?
                                            <Paper elevation={3} className="play-icon-container bg-black rounded">
                                                <button type="button"
                                                    className="bg-transparent border-0 p-0 play-icon-container"
                                                    onClick={e => {
                                                        this.setState({ ...this.state, bioSelected: bio, show: true })
                                                    }}>
                                                    <Card.Img className="" src={bio.video.frame.url} style={{ maxHeight: "7rem" }} alt="Card image" />

                                                    <div className="text-white play-icon row m-0 align-items-center">
                                                        <PlayCircleFilledIcon className="col" style={{ fontSize: '50px' }} />
                                                    </div>
                                                </button>
                                            </Paper>
                                            :
                                            <Paper elevation={3} >
                                                    <Card.Img className="" src={img} style={{ maxHeight: "7rem" }} alt="Card image" />
                                                </Paper>
                                        }
                                        <Row className="m-0">
                                            <Col xs={10} className="text-left p-0 bold mt-3">{bio.title}</Col>
                                            <Col xs={2} className="text-right p-0 bold">
                                                <button
                                                    className="dots-btn offset-3"
                                                    onClick={this.handleClick}>
                                                    <p className="mb-0 mt-1 font-21">...</p>
                                                    <ul className="shadow custom-list custom-position d-none">
                                                        <li className="list-style-none text-left">
                                                            {(bio.video) ?
                                                                <button
                                                                    onClick={() => {
                                                                        let id = bio.id
                                                                        this.props.profile_visume({
                                                                            variables: {
                                                                                "bio_id": id
                                                                            }
                                                                        }).then((res) => {
                                                                            if (res.data.Userupdate.Status.code === 200) {
                                                                                this.handleClose();
                                                                        
                                                                            }
                                                                        }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                                    }}
                                                                    className="bg-transparent border-0 p-0"
                                                                    type="button">
                                                                    <span className="pr-1">
                                                                        {(bio.is_my_profile_visume) ?
                                                                            <CheckCircleIcon className="text-orange" style={{ fontSize: "1rem" }} />
                                                                            : <CheckCircleIcon style={{ fontSize: "1rem" }} />
                                                                        }
                                                                    </span>
                                                            Select as a profile visume</button>
                                                                :
                                                                <button
                                                                    data-id={bio.id}
                                                                    disabled
                                                                    className="bg-transparent border-0 p-0"
                                                                    type="button">
                                                                    <span className="pr-1">
                                                                        <CheckCircleIcon style={{ fontSize: "1rem" }} />
                                                                    </span>
                                                                Select as a profile visume
                                                            </button>
                                                            }
                                                        </li>
                                                        <li className="list-style-none text-left">
                                                            <Link to={{
                                                                pathname: '/createVisume',
                                                                state: {
                                                                    data: bio,
                                                                    status: "Save Changes"
                                                                }
                                                            }}>
                                                                <button
                                                                    className="bg-transparent border-0 p-0"
                                                                    type="button">
                                                                    <span className="pr-1">
                                                                        <EditIcon style={{ fontSize: "1rem" }} />
                                                                    </span>
                                                                    Edit Visume
                                                                </button>
                                                            </Link>
                                                        </li>
                                                        <li className="list-style-none ">
                                                            <button
                                                                className="bg-transparent border-0 p-0 w-100 text-left"
                                                                type="button"
                                                                onClick={e => {
                                                                    this.setState({ ...this.state, bioSelected: bio, showDeleteModal: true })
                                                                }}>
                                                                <span className="pr-2"><DeleteIcon style={{ fontSize: "1rem" }} /></span>Delete </button>
                                                        </li>
                                                        <li className="list-style-none ">
                                                            {(bio.video) ?
                                                                <button
                                                                    className="bg-transparent border-0 p-0 w-100 text-left"
                                                                    type="button"
                                                                    onClick={e => {
                                                                        let link = bio.share_able_link;
                                                                        console.log(link)
                                                                        this.setState({ ...this.state, shareLink: link, showShareModal: true, copy: "Copy" })
                                                                    }}>
                                                                    <span className="pr-2"><ShareIcon style={{ fontSize: "1rem" }} /></span>Share </button>
                                                                : <button disabled
                                                                    className="bg-transparent border-0 p-0 w-100 text-left"
                                                                    type="button">
                                                                    <span className="pr-2"><ShareIcon style={{ fontSize: "1rem" }} /></span>Share </button>
                                                            }
                                                        </li>
                                                    </ul>
                                                </button>
                                            </Col>
                                        </Row>
                                        <Row className="m-0 pt-1  text-grey">
                                            {/* <Col xs={9} className="text-left p-0"><span className="text-orange">{bio.speciality.name_en} </span><br />{(bio.questions[0].video)?bio.questions[0].video.created_at.substring(0, 10): ''}</Col>
                                            <Col xs={3} className="text-right p-0">{bio.questions[0].maximum_time} Sec</Col> */}
                                        </Row>
                                    </Card>
                                </Col>
                            )})}
                    {
                    //   show video
                    (this.state.bioSelected) ?
                        <Modal
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className="row m-0 modal-video pr-0 biographies"
                            show={this.state.show}
                            onHide={this.handleClose}>
                            <Col xs={12} className="p-0">
                                <Modal.Body className="row m-0 p-0  bg-white rounded border-0">
                                    <Col xs={11} className="text-left p-0 bold p-2 pt-3 pb-2 captialize">
                                        <h6>{this.state.bioSelected.title}</h6>
                                    </Col>
                                    <Col xs={1} className=" text-right pl-0  pr-2 pt-3 pb-3  ">
                                        <button
                                            className="dots-btn offset-3"
                                            onClick={this.handleClick}>
                                            <img src={dots} alt="dots" />
                                            <ul className="shadow custom-list  d-none">
                                                <li className="list-style-none text-left">
                                                    <Link to={{
                                                        pathname: '/createVisume',
                                                        state: {
                                                            data: this.state.bioSelected,
                                                            status: "Save Changes"
                                                        }
                                                    }}>
                                                        <button
                                                            className="bg-transparent border-0 p-0"
                                                            type="button">
                                                            <span className="pr-1"><EditIcon style={{ fontSize: "1rem" }} /></span> Edit Visume</button>
                                                    </Link>
                                                </li>
                                                <li className="list-style-none ">
                                                    <button
                                                        className="bg-transparent border-0 p-0 w-100 text-left"
                                                        type="button"
                                                        onClick={e => {
                                                            this.setState({ ...this.state, bioSelected: this.state.bioSelected, showDeleteModal: true })
                                                        }}>
                                                        <span className="pr-2"><DeleteIcon style={{ fontSize: "1rem" }} /></span>Delete </button></li>
                                                <li className="list-style-none ">
                                                    <button
                                                        className="bg-transparent border-0 p-0 w-100 text-left"
                                                        type="button"
                                                        onClick={e => {
                                                            let link = this.state.bioSelected.video.url;
                                                            this.setState({ ...this.state, shareLink: link, showShareModal: true, copy: "Copy" })
                                                        }}>
                                                        <span className="pr-2"><ShareIcon style={{ fontSize: "1rem" }} /></span>Share </button>
                                                </li>
                                            </ul>
                                        </button>
                                    </Col>
                                    <Col md={10} xs={12} className="p-0 order-sm-4 order-2 bg-black rounded">
                                        <video controls autoPlay className="custom-iframe" title={this.state.bioSelected.title} src={(this.state.bioSelected.video) ? this.state.bioSelected.video.url : ''} width="100%" style={{ maxHeight: '33rem' }}></video>
                                    </Col>
                                    <Col md={2} xs={12} className="bg-lightgrey order-sm-5 order-5 modal-list-hight pr-1 pl-1">
                                        {
                                            this.arrayOfDuration.map(question =>
                                                (question.video !== null) ?
                                                    <button type="button"
                                                        className="bg-transparent btn-cuePoint p-0 w-100 rounded border-bottom border-0"
                                                        onClick={e => {
                                                            let video = document.querySelector('.custom-iframe');
                                                            video.currentTime = question.start_time
                                                        }}>
                                                        <Row className="m-0  pb-2">
                                                            <Col xs={1} className="p-0">
                                                                <EmojiFlagsIcon style={{ fontSize: "1rem" }} />
                                                            </Col>
                                                            <Col xs={11} className="p-0  text-left">
                                                                <p className="d-inline-block pl-2 captialize mb-0">
                                                                    {(question.title.length <= 15) ? question.title : question.title.substring(0, 15) + "..."}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </button> : ''
                                            )
                                        }
                                    </Col>
                                </Modal.Body>
                            </Col>
                        </Modal>
                        : ''
                    }
                    {/* delete modal */}
                    <Modal
                        size="md"
                        centered
                        className="row m-0 custom-modal-delete pr-0"
                        show={this.state.showDeleteModal}
                        onHide={this.handleCloseDeleteModal}>
                        <Col xs={12} className="p-0">
                            <Modal.Body className="p-1">
                                <h6>Are you sure you want to delete this Visume ?</h6>
                            </Modal.Body>
                            <Modal.Footer className="custom pt-3 pl-0 pr-0 pb-0">
                                <Row className="m-0 w-100">
                                    <Col xs={6} className="text-left p-0">
                                        <Button
                                            type="button"
                                            size="large"
                                            className="btn-white-outline  pr-5 pl-5" variant="contained"
                                            onClick={() => {
                                                this.handleCloseDeleteModal();
                                            }}>
                                            No
                                            </Button>
                                    </Col>
                                    <Col xs={6} className="text-right p-0">
                                        <Button
                                            type="button"
                                            size="large"
                                            className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                            onClick={() => {
                                                this.props.delete_bio({
                                                    variables: {
                                                        "bio_id": this.state.bioSelected.id
                                                    }
                                                }).then((res) => {
                                                    if (res.data.delete_bio.Status.code === 200) {
                                                        this.handleClose();
                                                        this.handleCloseDeleteModal();
                                                    }
                                                }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));

                                            }}>
                                            Yes, Delete
                                            </Button>
                                    </Col>
                                </Row>
                            </Modal.Footer>
                        </Col>
                    </Modal>
                    {/* share modal */}
                    <Modal
                        size="md"
                        centered
                        rounded
                        className="row m-0  pr-0"
                        show={this.state.showShareModal}
                        onHide={this.handleCloseShareModal}>
                        <Col xs={12} className="p-0">
                            <Modal.Header closeButton className="pr-3 pl-3 pt-2 pb-2">
                                <Modal.Title className='h6'>Share Visume</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pr-3 pl-3 pt-2 pb-2 text-center">
                                <Tooltip placement="left" title={this.state.copy} aria-label={this.state.copy}>
                                    <Fab size="small" className="custom-fab m-1">
                                        <CopyToClipboard
                                            onCopy={() => this.setState({ ...this.state, copy: "Copied", showShareModal: false })}
                                            text={this.state.shareLink}>
                                            <CodeSharpIcon size={32} />
                                        </CopyToClipboard>
                                    </Fab>
                                </Tooltip>
                                <EmailShareButton className="m-1" url={this.state.shareLink || ''}><EmailIcon size={40} round={true} /></EmailShareButton>
                                <LinkedinShareButton className="m-1" url={this.state.shareLink || ''}><LinkedinIcon size={40} round={true} /></LinkedinShareButton>
                                <FacebookShareButton className="m-1" url={this.state.shareLink || ''}><FacebookIcon size={40} round={true} /></FacebookShareButton>
                                <WhatsappShareButton className="m-1" url={this.state.shareLink || ''}><WhatsappIcon size={40} round={true} /></WhatsappShareButton>
                            </Modal.Body>
                        </Col>
                    </Modal>
                </Row>
            )
        }
    }
}
const DELETE_BIO = gql`
mutation($bio_id : Int !){
    bioDelete(Inputs: {
      id : $bio_id
    }){
      Status{
        code
      }
    }
  }
  
`
const PROFILE_VISUME = gql`
mutation($bio_id : Int !){
    Userupdate(data: {
      bio_id : $bio_id
    }){
      Status{
        code
      }
    }
  }
`
export default compose(
    graphql(DELETE_BIO, {
        name: "delete_bio"
    }),
    graphql(PROFILE_VISUME, {
        name: "profile_visume"
    })
)(withRouter(CardBiography));